(function () {
  if (window.lopRecentTeams) return;
  window.lopRecentTeams = true;
  var KEY = 'lop:recent-teams';
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  var cur = document.querySelector('[data-lop-rt-current]');
  if (cur) {
    try {
      var t = JSON.parse(cur.textContent);
      if (t && t.handle) {
        list = [t].concat(list.filter(function (x) { return x && x.handle !== t.handle; })).slice(0, 10);
        localStorage.setItem(KEY, JSON.stringify(list));
      }
    } catch (e) {}
  }
  var safe = function (u, re) { return typeof u === 'string' && re.test(u); };
  list = list.filter(function (x) { return x && safe(x.url, /^\/(?!\/)/); });
  if (!list.length) return;
  document.querySelectorAll('[data-lop-rt]').forEach(function (box) {
    var ul = box.querySelector('.lop-rt__list');
    var max = parseInt(box.getAttribute('data-max'), 10) || 6;
    list.slice(0, max).forEach(function (x) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'lop-rt__item';
      a.href = x.url;
      if (safe(x.color, /^#[0-9a-f]{3,8}$|^rgba?\([\d.,\s%]+\)$/i)) a.style.setProperty('--lop-rt-bg', x.color);
      if (safe(x.logo, /^(https:)?\/\//)) {
        var icon = document.createElement('span');
        icon.className = 'lop-rt__icon';
        var img = document.createElement('img');
        img.src = x.logo; img.alt = ''; img.width = 14; img.height = 14; img.loading = 'lazy';
        icon.appendChild(img);
        a.appendChild(icon);
      }
      var name = document.createElement('span');
      name.className = 'lop-rt__name';
      name.textContent = x.title || '';
      a.appendChild(name); li.appendChild(a); ul.appendChild(li);
    });
    box.hidden = false;
  });
})();
